import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { RestClientContinuable } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { Package } from './package'
import { PackagePatch } from './package-patch'
import { ItemUnitBundleCommand } from './bundling/item-unit-bundle-command'

export interface PackageProductionLinePath {
  path: string
  workCenterSequence: WorkCenterInfo[]
  display: string
}

export interface WorkCenterInfo {
  id: string
  number: string
}

@Injectable({
  providedIn: 'root',
})
export class PackageService extends RestClientContinuable<Package, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/packages', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public updateByPatch(patch: PackagePatch): Observable<Package> {
    /* todo requires custom update with generics */
    return this.update(<any>patch)
  }

  /***************************************************************************
   *                                                                         *
   * /api/packages/{id}/items                                                *
   *                                                                         *
   **************************************************************************/

  public executeBundleCommand(pkg: Package, command: ItemUnitBundleCommand): Observable<Package> {
    return this.http.post<Package>(`${this.restEndpoint}/${pkg.id}/items`, command)
  }

  /***************************************************************************
   *                                                                         *
   * /api/packages/work-order/{workOrderId}/production-line-paths            *
   *                                                                         *
   **************************************************************************/

  public fetchProductionLines(workOrderId: string): Observable<PackageProductionLinePath[]> {
    return this.http.get<PackageProductionLinePath[]>(
      `${this.restEndpoint}/work-order/${workOrderId}/production-line-paths`
    )
  }
}
